import React, {useState} from 'react';
import {Button} from 'react-bootstrap';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import { Modal } from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {useParams} from 'react-router-dom';
import {Form, Formik} from 'formik';
import * as actions from '../_redux/userDetailsActions';
import DataItemSelectAsync from '../../_common/components/DataItemSelectAsync';
import DataItemDatepicker from '../../_common/components/DataItemDatepicker';

const PopupAddInvitedBy = () => {
  const intl = useIntl();
  const prefix = 'userDetails-modal-add-user';
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const recipient = useParams().userId;
  const user = useSelector((state) => state.userDetails.user, shallowEqual);
  const getUsersDDList = (inputValue) => {
    return dispatch(actions.getUsersDDList(inputValue));
  };

  const handleSubmit = (values) => {
    const sender = values.name.value;
    const {username} = user;

    dispatch(actions.setInvitedUser(sender, recipient, values.name.label, username, values.date))
      .then(() => {
        dispatch(actions.fetchUser({userId: recipient}));
      })
      .then(() => handleCloseModal())
      .catch((error) => {
        console.error(`Error: + ${error}`);
      });
  };

  return (
    <>
      <Button
        className="btn btn-sm btn-primary font-weight-bold w-150px py-2 px-4 mt-4 mb-2 mx-auto d-block"
        onClick={handleShowModal}
      >
        {intl.formatMessage({id: `${prefix}-open`, defaultMessage: 'Add user'})}
      </Button>
      <Modal show={show} onHide={handleCloseModal}>
        <Formik
          initialValues={{name: '', date: new Date()}}
          validate={(values) => {
            let errors = {};
            if (!values.name) errors.name = 'Required';
            if (!values.date) errors.date = 'Required';

            return errors;
          }}
          onSubmit={() => {}}
          validateOnMount={true}
        >
          {({values, isValid}) => (
            <>
              <Modal.Body>
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <h6 className="font-weight-bolder text-dark text-center pb-8">
                    {intl.formatMessage({id: `${prefix}-header`, defaultMessage: 'Select user who invited'})}
                  </h6>
                  <Form>
                    <div className={'w-300px mb-4'}>
                      <div className={'font-weight-bolder font-size-lg'}>
                        {intl.formatMessage({id: `${prefix}-label-user`, defaultMessage: 'User'})}
                      </div>
                      <DataItemSelectAsync
                        fieldId={'name'}
                        loadOptions={getUsersDDList}
                      />
                    </div>
                    <div className={'w-300px mb-4'}>
                      <div className={'font-weight-bolder font-size-lg'}>
                        {intl.formatMessage({id: `${prefix}-label-date`, defaultMessage: 'Date'})}
                      </div>
                      <DataItemDatepicker
                        fieldId={'date'}
                        customClassName={'invited-user-datepicker'}
                      />
                    </div>
                  </Form>
                </div>
              </Modal.Body>
              <Modal.Footer className="justify-content-center border-0 pt-0">
                <Button
                  variant="secondary"
                  onClick={handleCloseModal}
                >
                  {intl.formatMessage({id: `${prefix}-cancel`, defaultMessage: 'Cancel'})}
                </Button>
                <Button
                  variant="primary"
                  onClick={() => handleSubmit(values)}
                  disabled={!isValid}
                >
                  {intl.formatMessage({id: `${prefix}-ok`, defaultMessage: 'OK'})}
                </Button>
              </Modal.Footer>
            </>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default PopupAddInvitedBy;
